function radius(theme) {
  return function (size) {
    if (typeof size === "number") {
      return size;
    }

    var defaultRadius = typeof theme.defaultRadius === "number" ? theme.defaultRadius : theme.radius[theme.defaultRadius] || theme.defaultRadius;
    return theme.radius[size] || size || defaultRadius;
  };
}

export { radius };